import React, { useState } from "react";
import { motion } from "framer-motion";
import { submitTradeIn } from "../lib/api";
import { toast } from "sonner";
import { Repeat } from "lucide-react";

export default function TradeIn() {
  const [form, setForm] = useState({
    full_name: "", email: "", phone: "", make: "", model: "", year: 2020, mileage: 40000, condition: "good", notes: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await submitTradeIn({ ...form, year: Number(form.year), mileage: Number(form.mileage) });
      toast.success("Trade-in submitted. Expect an offer within 48 hours.");
      setForm({ ...form, notes: "" });
    } catch {
      toast.error("Submission failed. Please try again.");
    } finally { setSubmitting(false); }
  };

  return (
    <div data-testid="page-trade-in" className="pt-32 pb-24 max-w-[1500px] mx-auto px-6 md:px-10">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <div className="overline flex items-center gap-3"><Repeat size={14} /> Trade-In</div>
        <h1 className="font-display text-6xl md:text-8xl mt-3 tracking-tighter">
          Turn your ride
          <br />
          <span className="text-[var(--primary)]">into a down payment.</span>
        </h1>
        <p className="text-white/60 mt-6 max-w-xl">
          Tell us about your current car. We'll come back with a real, no-obligation offer within 48 hours.
        </p>
      </motion.div>

      <form onSubmit={onSubmit} className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl" data-testid="trade-in-form">
        <div>
          <label>Full name</label>
          <input required data-testid="ti-name" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
        </div>
        <div>
          <label>Email</label>
          <input required type="email" data-testid="ti-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <div>
          <label>Phone</label>
          <input required data-testid="ti-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        </div>
        <div>
          <label>Vehicle year</label>
          <input required type="number" data-testid="ti-year" value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} />
        </div>
        <div>
          <label>Make</label>
          <input required data-testid="ti-make" value={form.make} onChange={(e) => setForm({ ...form, make: e.target.value })} />
        </div>
        <div>
          <label>Model</label>
          <input required data-testid="ti-model" value={form.model} onChange={(e) => setForm({ ...form, model: e.target.value })} />
        </div>
        <div>
          <label>Mileage</label>
          <input required type="number" data-testid="ti-mileage" value={form.mileage} onChange={(e) => setForm({ ...form, mileage: e.target.value })} />
        </div>
        <div>
          <label>Condition</label>
          <select data-testid="ti-condition" value={form.condition} onChange={(e) => setForm({ ...form, condition: e.target.value })}>
            <option value="excellent">Excellent</option>
            <option value="good">Good</option>
            <option value="fair">Fair</option>
            <option value="poor">Poor</option>
          </select>
        </div>
        <div className="md:col-span-2">
          <label>Notes</label>
          <textarea rows={4} data-testid="ti-notes" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Modifications, accident history, options..." />
        </div>
        <div className="md:col-span-2">
          <button disabled={submitting} type="submit" className="btn-primary" data-testid="ti-submit">
            {submitting ? "Sending..." : "Get My Offer"}
          </button>
        </div>
      </form>
    </div>
  );
}
